import { render, staticRenderFns } from "./month.vue?vue&type=template&id=b21c31dc&scoped=true&"
import script from "./month.vue?vue&type=script&lang=js&"
export * from "./month.vue?vue&type=script&lang=js&"
import style0 from "./month.vue?vue&type=style&index=0&id=b21c31dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21c31dc",
  null
  
)

export default component.exports